export default __webpack_public_path__ + "static/media/hht2_Intonation_18.8f3f48b8.png";